import { analyticsContext } from './analytics-context.ts';
import { type CanvasAnalyticsWebClient } from './analytics-web-client.ts';

export type OperationalAnalyticsEvent = Parameters<
  CanvasAnalyticsWebClient['sendOperationalEvent']
>[0];

export const fireOperationalEvent = async (event: OperationalAnalyticsEvent) => {
  if (!analyticsContext.client) {
    return;
  }

  try {
    await analyticsContext.client.sendOperationalEvent(event);
  } catch (e) {
    console.error(e);
  }
};
